import React, { useEffect, useState, useContext } from "react";
import MyNavbar from "../../../components/customer/myNavbar/MyNavbar";
import Footer from "../../../components/customer/footer/Footer";
import "../../../assets/css/customer/screens/blogScreen/BlogDetailPage.css";
import AppContext from "../../../context/AppContext";
import {useNavigate } from "react-router-dom";
// ─── Sample Data (replace with API/props) ──────────────────
// const blogData = {
//   id: 1,
//   category: "SKINCARE",
//   title: "5 Skincare Basics Every Patient Should Follow",
//   date: "May 02, 2026",
//   readTime: "4 min read",
//   author: "Dr. Ayesha Malik",
//   authorRole: "Senior Dermatologist",
//   authorAvatar: "A",
//   heroImage: "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=1200&q=80",
//   content: [
//     {
//       type: "intro",
//       text: "Taking care of your skin doesn't have to be complicated. Whether you're dealing with acne, dryness, or just want to maintain a healthy glow, these five fundamentals will transform your skincare routine and give you long-lasting results.",
//     },
//     { type: "heading", text: "1. Cleanse Gently, Twice a Day" },
//     {
//       type: "paragraph",
//       text: "The foundation of any good skincare routine is proper cleansing. Washing your face morning and night removes dirt, oil, and environmental pollutants that accumulate throughout the day. Choose a gentle, pH-balanced cleanser suited to your skin type — avoid harsh soaps that strip natural oils and disrupt your skin barrier.",
//     },
//     { type: "heading", text: "2. Never Skip Sunscreen" },
//     {
//       type: "paragraph",
//       text: "UV damage is the number one cause of premature aging and a major risk factor for skin cancer. Apply a broad-spectrum SPF 30 or higher every single morning — even on cloudy days or when staying indoors near windows. Sunscreen is the most powerful anti-aging product you can use.",
//     },
//     {
//       type: "highlight",
//       text: '"SPF is not optional — it\'s the single most important step in your daily skincare routine, regardless of skin type or season."',
//     },
//     { type: "heading", text: "3. Moisturize to Strengthen Your Skin Barrier" },
//     {
//       type: "paragraph",
//       text: "A healthy moisture barrier keeps irritants out and hydration in. Even oily skin types need moisturizer — dehydrated skin overproduces oil to compensate. Look for ingredients like hyaluronic acid, ceramides, and glycerin that attract and lock in moisture without clogging pores.",
//     },
//     { type: "heading", text: "4. Exfoliate — But Don't Overdo It" },
//     {
//       type: "paragraph",
//       text: "Exfoliation removes dead skin cells that make skin look dull and can cause breakouts. Chemical exfoliants like AHAs and BHAs are gentler and more effective than physical scrubs. Limit exfoliation to 2–3 times a week to avoid irritation.",
//     },
//     { type: "heading", text: "5. Stay Consistent and Be Patient" },
//     {
//       type: "paragraph",
//       text: "Skincare is a marathon, not a sprint. Most products take 4–12 weeks to show visible results. Stick to your routine consistently, introduce new products one at a time, and document your progress with photos every few weeks to track improvements.",
//     },
//     {
//       type: "conclusion",
//       text: "These five basics form the cornerstone of healthy, radiant skin. Book a consultation with our dermatologists at Estatica to get a personalized skincare plan tailored to your unique skin needs.",
//     },
//   ],
//   tags: ["Skincare", "Dermatology", "Beauty Tips", "SPF", "Hydration"],
//   relatedPosts: [
//     {
//       id: 2,
//       title: "Laser Hair Removal: What to Expect",
//       date: "Apr 18, 2026",
//       readTime: "5 min read",
//       image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&q=80",
//     },
//     {
//       id: 3,
//       title: "Chemical Peels: Benefits & Recovery",
//       date: "Apr 05, 2026",
//       readTime: "6 min read",
//       image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400&q=80",
//     },
//     {
//       id: 4,
//       title: "Best Treatments for Acne Scars",
//       date: "Mar 22, 2026",
//       readTime: "4 min read",
//       image: "https://images.unsplash.com/photo-1612817288484-6f916006741a?w=400&q=80",
//     },
//   ],
// };

// ─── Content Block Renderer ────────────────────────────────
function ContentBlock({ block, index }) {
  switch (block.type) {
    case "intro":
      return <p key={index} className="blog-detail__intro">{block.text}</p>;

    case "heading":
      return <h2 key={index} className="blog-detail__heading">{block.text}</h2>;

    case "paragraph":
      return <p key={index} className="blog-detail__paragraph">{block.text}</p>;

    case "highlight":
      return <blockquote key={index} className="blog-detail__highlight">{block.text}</blockquote>;

    case "conclusion":
      return (
        <div key={index} className="blog-detail__conclusion">
          <p>{block.text}</p>
          <button className="blog-detail__conclusion-btn">Book a Consultation →</button>
        </div>
      );

    default:
      return null;
  }
}

// ─── Main Component ────────────────────────────────────────
export default function BlogDetailPage() {
  const navigate = useNavigate();
  const { baseUrl , baseUrlForFile,selectedPostFromLandingPage} = useContext(AppContext);
  const [liked, setLiked]           = useState(false);
  const [likeCount, setLikeCount]   = useState(48);
  const [bookmarked, setBookmarked] = useState(false);

  const handleLike = () => {
    setLikeCount(liked ? likeCount - 1 : likeCount + 1);
    setLiked(!liked);
  };
    useEffect(() => {
  
      console.log(selectedPostFromLandingPage);
  }, []);
  
  
    if (!selectedPostFromLandingPage){
          return (
            <>
            <MyNavbar/>
    <div>
      <p>Blog not found.</p>

      <button onClick={() => navigate("/blogs")}>
        ← Back to Blogs
      </button>
    </div>
    <Footer/>
    </>
  );
}

  return (
    <>
<MyNavbar/>
    <div className="blog-detail__page">

      {/* ── Breadcrumb ── */}
      {/* <div className="blog-detail__breadcrumb">
        <span className="bc-home">Home</span>
        <span className="bc-sep">›</span>
        <span className="bc-blogs">Blogs</span>
        <span className="bc-sep">›</span>
        <span className="bc-current">5 Skincare Basics</span>
      </div> */}

      {/* ── Main Content ── */}
      <div className="blog-detail__main">

        {/* Category */}
        <div className="blog-detail__category">{selectedPostFromLandingPage?.category}</div>

        {/* Title */}
        <h1 className="blog-detail__title">{selectedPostFromLandingPage?.title}</h1>

        {/* Meta Card */}
        <div className="blog-detail__meta-card">

          <div className="blog-detail__author">
            <div className="blog-detail__avatar">{selectedPostFromLandingPage?.authorAvatar}</div>
            <div>
              <div className="blog-detail__author-name">{selectedPostFromLandingPage?.author}</div>
              <div className="blog-detail__author-role">{selectedPostFromLandingPage?.authorRole}</div>
            </div>
          </div>

          <span className="blog-detail__meta-sep">|</span>
          <span className="blog-detail__meta-date">📅 {selectedPostFromLandingPage?.excerpt}</span>
          <span className="blog-detail__meta-dot">·</span>
          <span className="blog-detail__meta-read">⏱ {selectedPostFromLandingPage?.excerpt}</span>

          <div className="blog-detail__meta-actions">
            <button
              className={`blog-detail__btn-like ${liked ? "liked" : ""}`}
              onClick={handleLike}
            >
              {liked ? "❤️" : "🤍"} {likeCount}
            </button>
            <button
              className={`blog-detail__btn-save ${bookmarked ? "saved" : ""}`}
              onClick={() => setBookmarked(!bookmarked)}
            >
              {bookmarked ? "🔖" : "📄"} Save
            </button>
          </div>
        </div>

        {/* Hero Image */}
        <div className="blog-detail__hero-wrap">
          <img   src={`${baseUrlForFile}/${selectedPostFromLandingPage?.image}`} alt={selectedPostFromLandingPage?.title} />
        </div>

        {/* Article Body */}
       <div className="blog-detail__body">

   <p className="blog-detail__paragraph">
      {selectedPostFromLandingPage?.body}
   </p>

</div>

        {/* Tags */}
        <div className="blog-detail__tags">
          {selectedPostFromLandingPage?.tags?.map((tag) => (
            <span key={tag} className="blog-detail__tag">#{tag}</span>
          ))}
        </div>

        <hr className="blog-detail__divider" />

        {/* Share */}
        <div className="blog-detail__share">
          <div className="blog-detail__share-label">Share this article:</div>
          <div className="blog-detail__share-btns">
            <button className="blog-detail__share-btn share-facebook">Facebook</button>
            <button className="blog-detail__share-btn share-twitter">Twitter</button>
            <button className="blog-detail__share-btn share-whatsapp">WhatsApp</button>
            <button className="blog-detail__share-btn share-copy">Copy Link</button>
          </div>
        </div>

        {/* Related Posts */}
        {/* <div>
          <div className="blog-detail__related-label">KEEP READING</div>
          <h3 className="blog-detail__related-title">Related Articles</h3>
          <div className="blog-detail__related-grid">
            {selectedPostFromLandingPage?.relatedPosts?.map((post) => (
              <div key={post.id} className="blog-detail__related-card">
                <img src={post.image} alt={post.title} />
                <div className="blog-detail__related-info">
                  <div className="blog-detail__related-meta">
                    {post.date} · {post.readTime}
                  </div>
                  <div className="blog-detail__related-name">{post.title}</div>
                  <div className="blog-detail__related-link">Read more →</div>
                </div>
              </div>
            ))}
          </div>
        </div> */}

      </div>

      {/* ── Footer CTA ── */}
      <div className="blog-detail__footer-wrap">
        <div className="blog-detail__footer-card">
          <h2 className="blog-detail__footer-title">
            Book your skin consultation<br />today
          </h2>
          <p className="blog-detail__footer-sub">
            A 30-minute consultation with our dermatologists to<br />
            map a treatment plan tailored to your skin.
          </p>
          <button className="blog-detail__footer-btn">Book Appointment</button>
        </div>
      </div>

    </div>
    <Footer/>
    </>
  );
}